import agit_new from '../img/ico/1.svg'
import fire_new from '../img/ico/2.svg'
import meet_new from '../img/ico/3.svg'
import personnel_new from '../img/ico/4.svg'
import sabotage_new from '../img/ico/5.svg'
import action_new from '../img/ico/6.svg'
import walk_new from '../img/ico/7.svg'
import pubp_new from '../img/ico/8.svg'

const dataIcons = {
    0:agit_new,  // без 1
    1:action_new,      // акция 6
    2:personnel_new,  // одиночный пикет 4
    3:walk_new,    // марш 7
    4:sabotage_new,   // саботаж 5
    5:meet_new,    // митинг 3
    6:agit_new,       // Агитация 1
    7:fire_new,       // Радикальное действие 2
    8:pubp_new,       // Публичное заявление 8
}

export const getIconById = (id) =>{
    return dataIcons[id] ? dataIcons[id] : dataIcons[0]
}


